import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import Hero from './sections/Hero';
import About from './sections/About';

export default function Landing() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Footer />
    </>
  );
}
